import React, { useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { FaChevronDown } from "react-icons/fa";
import "react-accessible-accordion/dist/fancy-example.css";
import "./Quotation.css";

const currency = (value) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2,
  }).format(value || 0);

const Quotations = ({ quotations }) => {
  const [data, setData] = useState([]);
  const [expanded, setExpanded] = useState(true);

  useEffect(() => {
    if (Array.isArray(quotations)) {
      setData(quotations);
    } else if (quotations?.items) {
      setData(quotations.items);
    }
  }, [quotations]);

  const columns = useMemo(
    () => [
      {
        name: "Service",
        grow: 2,
        cell: (row) => (
          <div>
            <div className="service-meta-table">{row.service_name || "-"}</div>
            <div className="service-meta-table">
              {row.resource_category} • {row.service_type}
            </div>
          </div>
        ),
      },
      {
        name: "Start",
        selector: (row) => row.start_date || "-",
      },
      {
        name: "End",
        selector: (row) => row.end_date || "-",
      },
      {
        name: "Duration",
        selector: (row) =>
          row.duration || row.duration_days
            ? `${row.duration || row.duration_days}`
            : "-",
        right: true,
      },
      {
        name: "Adjustment",
        selector: (row) => currency(row.price_adjustment),
        right: true,
      },
      {
        name: "Final Price",
        selector: (row) => currency(row.final_price),
        right: true,
      },
    ],
    [],
  );

  if (!data.length) return null;

  return (
    <Accordion
      key={expanded ? "open" : "closed"}
      allowZeroExpanded
      preExpanded={expanded ? ["quotations"] : []}
      onChange={(uuids) => setExpanded(uuids.includes("quotations"))}
    >
      <AccordionItem uuid="quotations">
        <AccordionItemHeading>
          <AccordionItemButton className="bd-header">
            <h4 className="bd-title">Quotations | Payments Track</h4>
            <span className="bd-add-btn">
              View Details
              <FaChevronDown
                style={{
                  transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease",
                  marginLeft: "6px",
                }}
              />
            </span>
          </AccordionItemButton>
        </AccordionItemHeading>

        <AccordionItemPanel className="bd-panel">
          <div className="quotation-card">
            <DataTable
              columns={columns}
              data={data}
              dense
              highlightOnHover
              striped={false}
              persistTableHead
              noDataComponent="No quotations found"
              customStyles={{
                headCells: {
                  style: {
                    fontWeight: 600,
                    fontSize: "13px",
                    backgroundColor: "#E1FCFF",
                  },
                },
                rows: {
                  style: {
                    minHeight: "56px",
                    borderBottom: "1px solid #E8E8E8",
                  },
                },
                cells: {
                  style: {
                    fontSize: "13px",
                  },
                },
              }}
            />
          </div>

          <div className="quotation-summary">
            <div className="summary-row">
              <span>Total Amount</span>
              <strong>{currency(quotations?.total_amount)}</strong>
            </div>

            <div className="summary-row net">
              <span>Net Amount</span>
              <strong>{currency(quotations?.net_amount)}</strong>
            </div>
          </div>
        </AccordionItemPanel>
      </AccordionItem>
    </Accordion>
  );
};

export default Quotations;
